// src/components/TrialBannerFamiliar.jsx
// Banner de trial para el dashboard del familiar
// Muestra alerta cuando hay abuelos con trial a punto de expirar

import React, { useState } from 'react';

/**
 * Banner que muestra cuando hay abuelos con trial expirando
 * @param {Array} abuelos - Lista de abuelos con trial expirando
 * @param {Function} onUpgradeClick - Callback cuando hace clic en upgrade
 */
const TrialBannerFamiliar = ({ abuelos = [], onUpgradeClick }) => {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed || abuelos.length === 0) return null;

  // Encontrar el abuelo con menos días de trial
  const abueloUrgente = abuelos.reduce((prev, curr) => {
    const diasPrev = getDiasRestantes(prev);
    const diasCurr = getDiasRestantes(curr);
    return diasCurr < diasPrev ? curr : prev;
  }, abuelos[0]);

  const diasRestantes = getDiasRestantes(abueloUrgente);
  const isUrgent = diasRestantes <= 2;

  function getDiasRestantes(abuelo) {
    if (!abuelo.fecha_fin_trial) return 999;
    const fechaFin = new Date(abuelo.fecha_fin_trial);
    const ahora = new Date();
    const dias = Math.ceil((fechaFin - ahora) / (1000 * 60 * 60 * 24));
    return dias > 0 ? dias : 0;
  }

  const handleUpgrade = () => {
    if (onUpgradeClick) {
      onUpgradeClick(abueloUrgente);
    }
  };

  return (
    <div 
      className={`w-full ${isUrgent ? 'bg-gradient-to-r from-red-500 to-orange-500' : 'bg-gradient-to-r from-purple-500 to-pink-500'} text-white shadow-lg`}
      style={{ padding: '12px 16px' }}
    >
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        gap: '16px',
        flexWrap: 'wrap'
      }}>
        {/* Contenido */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
          {/* Icono */}
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: 'rgba(255,255,255,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px',
            flexShrink: 0
          }}>
            {isUrgent ? '⚠️' : '🎁'}
          </div>
          
          {/* Texto */}
          <div>
            <p style={{ fontWeight: '600', fontSize: '14px', margin: 0 }}>
              {abuelos.length === 1 ? (
                isUrgent 
                  ? `¡La prueba de ${abueloUrgente.nombre} termina ${diasRestantes === 0 ? 'HOY' : diasRestantes === 1 ? 'MAÑANA' : `en ${diasRestantes} días`}!`
                  : `La prueba de ${abueloUrgente.nombre} termina en ${diasRestantes} días`
              ) : (
                `${abuelos.length} abuelos con prueba a punto de expirar`
              )}
            </p>
            <p style={{ fontSize: '12px', opacity: 0.9, margin: '2px 0 0 0' }}>
              {isUrgent 
                ? 'Elige un plan para que pueda seguir usando Doña Paquita' 
                : 'Elige un plan antes de que termine el período de prueba'}
            </p>
          </div>
        </div>
        
        {/* Botones */}
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <button
            onClick={handleUpgrade}
            style={{
              padding: '8px 20px',
              borderRadius: '8px',
              border: 'none',
              fontWeight: '600',
              fontSize: '14px',
              cursor: 'pointer',
              backgroundColor: 'white',
              color: isUrgent ? '#dc2626' : '#9333ea',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Elegir plan →
          </button>
          
          {!isUrgent && (
            <button
              onClick={() => setIsDismissed(true)}
              style={{
                padding: '8px',
                borderRadius: '50%',
                border: 'none',
                backgroundColor: 'rgba(255,255,255,0.2)',
                color: 'white',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '16px'
              }}
              title="Cerrar"
            >
              ✕
            </button>
          )}
        </div>
      </div>
      
      {/* Barra de progreso */}
      <div style={{ 
        marginTop: '8px', 
        maxWidth: '1200px', 
        margin: '8px auto 0'
      }}>
        <div style={{
          height: '4px',
          backgroundColor: 'rgba(255,255,255,0.3)',
          borderRadius: '2px',
          overflow: 'hidden'
        }}>
          <div 
            style={{
              height: '100%',
              backgroundColor: 'rgba(255,255,255,0.8)',
              borderRadius: '2px',
              transition: 'width 0.5s',
              width: `${Math.max(0, Math.min(100, ((7 - diasRestantes) / 7) * 100))}%`
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TrialBannerFamiliar;